import React from "react";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { DictCodeEnmu } from "@/types/AppDictEnums";
import { useDictModel } from "@/views/base/dict/dictModel";
import { useWlocModel } from "../wlocModel";

export function PageHeader() {
    const { getSelectedDictOne } = useDictModel(() => []);
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useWlocModel();

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "信用证号",
            fieldName: "code",
        },
        {
            type: SearchTypeEnum.Datepicker,
            placeholder: "到证日期",
            fieldName: "confirmTime",
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "交单日期预警状态",
            fieldName: "presentWarningType",
            options:getSelectedDictOne(DictCodeEnmu.WARNING)
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "最迟船期预警状态",
            fieldName: "endWarningType",
            options:getSelectedDictOne(DictCodeEnmu.WARNING)
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "到证日期预警状态",
            fieldName: "confirmWarningType",
            options:getSelectedDictOne(DictCodeEnmu.WARNING)
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "信用证类型",
            fieldName: "creditType",
            options:getSelectedDictOne(DictCodeEnmu.EXPORT_CREDIT_TYPE)
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "币种",
            fieldName: "currency",
            options:getSelectedDictOne(DictCodeEnmu.CURRENCY)
        },
    ]

    return (
        <YhPageHeader
            title="信用证预警列表"
            size="small"
            justify="end"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}